function formatScaled(value, divisor, suffix) {
  const scaled = value / divisor;

  if (scaled >= 100) {
    return `${Math.round(scaled)}${suffix}`;
  }

  const rounded = Math.round(scaled * 10) / 10;
  const text = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1).replace(/\.0$/, '');
  return `${text}${suffix}`;
}

/** Abbreviate XP values > 999: thousands as K, millions as M, billions as B */
export function formatAbbreviatedXp(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return '0';

  if (num >= 1_000_000_000) {
    return formatScaled(num, 1_000_000_000, 'B');
  }

  if (num >= 1_000_000) {
    return formatScaled(num, 1_000_000, 'M');
  }

  if (num > 999) {
    return formatScaled(num, 1_000, 'K');
  }

  return String(Math.round(num));
}

export function formatXpCost(value) {
  return `${formatAbbreviatedXp(value)} XP`;
}
